import { InjectionToken } from '@angular/core';

export const ENV_CONFIG: InjectionToken<EnvConfig> = new InjectionToken<EnvConfig>('ENV_CONFIG');

export interface EnvConfig {
  environment: string;
  production: boolean;
  apiUrl: string;
  frontendUrl: string;
  customUrl: string;
  androidApkUrl: string;
  iOSApkUrl: string;
  mapboxToken: string;
  mapApiKey: string;
  chatToken: string;
  appsFlyerDevKey: string;
  appsFlyerOneLinkDomain: string;
  appsFlyerOneLinkTemplateId: string;
  appId: string;
  facebookAppId: string;
}
